import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomHeading from "../../components/customHeading";
import CustomButton from "../../components/customButton";
import PaginatedTable from "../../components/dynamicTable";
import { getForms, deleteForm } from "../../services/forms";
import { openSnackAlert } from "../../helper";
import AppLoader from "../../components/appLoader";
import AddIcon from "@mui/icons-material/Add";

const tableHeaders = [
  { title: "FORM TITLE", value: "title", align: "center" },
  { title: "FIELDS", value: "fieldsCount", align: "center" },
  { title: "ACTION", value: "actions", align: "center" },
];

const displayRows = tableHeaders.map((header) => header.value);

const CustomForm = () => {
  const navigate = useNavigate();
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchForms();
  }, []);

  const fetchForms = async () => {
    try {
      setLoading(true);
      const response = await getForms();
      if (response?.status === 200 || response?.status === 201) {
        setForms(response.data?.data.customForms || response.data || []);
      }
    } catch (error) {
      openSnackAlert("Error loading forms", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (row) => {
    navigate(`/edit-custom-form/${row._id}`);
  };

  const handleDelete = async (row) => {
    if (!window.confirm("Are you sure you want to delete this form?")) {
      return;
    }
    try {
      setLoading(true);
      const response = await deleteForm(row._id);
      if (response?.status === 200 || response?.status === 201) {
        openSnackAlert("Form deleted successfully", "success");
        fetchForms();
      } else {
        openSnackAlert("Failed to delete form", "error");
      }
    } catch (error) {
      openSnackAlert("Error deleting form", "error");
    } finally {
      setLoading(false);
    }
  };

  const tableData = forms.map((form) => ({
    ...form,
    title: form.title,
    fieldsCount: form.fields?.length || 0,
  }));

  return (
    <>
      <Box
        bgcolor="primary.bgLight"
        padding={"20px"}
        borderRadius={"22px"}
        mt={0}
      >
        <AppLoader isVisible={loading} />
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <CustomHeading
            tittle="Custom Form"
            subtittle="Create a custom form to collect data from your employees"
          />
          <CustomButton
            btnLabel="Create Form"
            handlePressBtn={() => navigate("/add-custom-form")}
            variant={"webbutton"}
            startIcon={<AddIcon color="white" />}
          />
        </Box>
        <Box mt={3}>
          <PaginatedTable
            tableHeader={tableHeaders}
            tableData={tableData}
            displayRows={displayRows}
            onEdit={handleEdit}
            onDelete={handleDelete}
            showPagination={false}
          />
        </Box>
      </Box>
    </>
  );
};

export default CustomForm;
